module.exports = __webpack_public_path__ + "static/media/3680.aacaae12.jpg";